import styled from '@emotion/styled';
import { HiHeart, HiOutlineHeart } from 'react-icons/hi';

export const IconHeart = styled(HiHeart)`
  display: block;
  width: 18px;
  height: 18px;
  color: #3470ff;
`;

export const IconHeartActive = styled(HiOutlineHeart)`
  display: block;
  width: 18px;
  height: 18px;
  color: #ffffff 80%;
`;
